<template>
  <div>
    <p class="pass-step-description">
      {{ passDetail.company_name }} would like to access to your details.
    </p>

    <p class="pass-step-description">
      Reason for collecting: {{ passDetail.reason_for_collecting }}
    </p>

    <div v-if="!isPreview" class="pass-step-share-details">
      <div v-if="userProfile !== undefined">
        <ul v-if="!isConstructing">
          <li v-for="(data, index) in passDetail.included_pass_details" :key="index">
            <div v-if="!isBlankValue(includedPassDetails[index])">
              <p>{{ data }}</p>
              <p>{{ userProfile.profile_details[includedPassDetails[index]] }}</p>
            </div>

            <form-group v-else-if="isBlankValue(includedPassDetails[index])" :attribute="data">
              <label :for="data">{{ data }}</label>
              <input type="text"
                class="form-control"
                v-model="form.user_details[includedPassDetails[index]]"
                :placeholder="data"/>
              <small class="form-text text-muted error-message"
                v-if="errors.user_details[includedPassDetails[index]]">
                {{ errors.user_details[includedPassDetails[index]] }}
              </small>
            </form-group>
          </li>
        </ul>

        <div v-for="(data, index) in passDetail.pass_access_questions" :key="index">
          <form-group :attribute="data.question">
            <label :for="data.question">{{ data.question }}</label>
            <input type="text"
              class="form-control"
              v-model="form.pass_access_questions[passAccessQuestionDetails[index]]"
              :placeholder="data.question"/>
            <small class="form-text text-muted error-message"
              v-if="errors.pass_access_questions[passAccessQuestionDetails[index]]">
              {{ errors.pass_access_questions[passAccessQuestionDetails[index]] }}
            </small>
          </form-group>
        </div>

        <div class="d-flex flex-row step-cta">
          <button
            v-if="isUserInvited || !isRequestNeedsApproval"
            class="btn btn-primary btn-active pass-step-primary-btn step-cta-row"
            @click="updateGetPass()"
            type="button"
          >Get Pass</button>
          <button
            v-else
            class="btn btn-primary pass-step-primary-btn step-cta-row"
            @click="updateGetPass()"
            type="button"
          >Request</button>
          <a
            v-bind:href="stepInquiryQuestion"
            class="step-cta-row simple-link"
          >I have some questions.</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/styles/pass-share-steps.css'

import InputComponent from '@/components/form/InputComponent'

export default {
  name: 'step-share-details',
  components: {
    InputComponent
  },
  data() {
    return {
      form: {
        user_details: {},
        pass_access_questions: {},
        pass_access_questions_response: []
      },
      errors: {
        user_details: {},
        pass_access_questions: {}
      },
      includedPassDetails: [],
      formValidate: [],
      passAccessQuestionDetails: [],
      isConstructing: true,
      hasError: false
    }
  },
  props: {
    passDetail: {
      type: Object,
      required: true
    },
    isToVerifyIdentity: {
      type: Boolean,
      required: true,
      default: true
    },
    isPreview: Boolean,
    userProfile: {
      type: Object,
      required: true
    },
    updateFunc: Function,
    stepInquiryQuestion: String,
    isUserInvited: Boolean,
    isRequestNeedsApproval: Boolean
  },
  watch: {
    userProfile(newVal, oldVal) {
      this.userProfile = newVal
    }
  },
  mounted() {
    this.updateProfileDetails()
    this.constructData()
  },
  methods: {
    isBlankValue(param) {
      return this.userProfile.profile_details[param] === 'none' ||
        this.userProfile.profile_details[param] === undefined
    },
    constructData() {
      this.includedPassDetails = this.passDetail.included_pass_details.map(d => {
        return d.split(' ').length - 1 >= 1
          ? d.toLowerCase().replace(/ /g, '_')
          : d.toLowerCase()
      })

      // could be refactored
      this.includedPassDetails.map(d => {
        if(this.isBlankValue(d)) this.formValidate.push(d)
      })

      this.passAccessQuestionDetails = this.passDetail.pass_access_questions.map(d => {
        const str = d.question.includes('?') ? d.question.replace('?', '') : d.question
        const question = str.split(' ').length - 1 >= 1
          ? str.toLowerCase().replace(/ /g, '_') : str.toLowerCase()
        this.formValidate.push(question)
        return question
      })
    },
    updateProfileDetails() {
      const firstName = this.userProfile.profile_details.first_name
      const lastName = this.userProfile.profile_details.last_name
      const fullName = `${firstName} ${lastName}`
      const userEmail = `${this.userProfile.email_address}`
      this.userProfile.profile_details.full_name = fullName
      this.userProfile.profile_details.email_address = userEmail
      this.isConstructing = false
    },
    updateGetPass() {
      // could be refactored
      this.errors.user_details = {}
      this.errors.pass_access_questions = {}
      this.hasError = false

      this.formValidate.map(d => {
        if(this.form.user_details[d] === '' ||
          this.form.user_details[d] === undefined) {
          this.errors.user_details[d] = 'This field is required'
          this.hasError = true
        }
        else this.resetError()

        if(this.form.pass_access_questions[d] === '' ||
          this.form.pass_access_questions[d] === undefined) {
          this.errors.pass_access_questions[d] = 'This field is required'
          this.hasError = true
        }
        else this.resetError()
      })

      if(!this.hasError) {
        if(Object.keys(this.form.pass_access_questions).length !== 0) {
          this.passDetail.pass_access_questions.map(d => {
            const str = d.question.includes('?') ? d.question.replace('?', '') : d.question
            const question = str.split(' ').length - 1 >= 1
              ? str.toLowerCase().replace(/ /g, '_') : str.toLowerCase()
            const passAccess = {
              question: d.question,
              response: this.form.pass_access_questions[question]
            }
            this.form.pass_access_questions_response.push(passAccess)
          })
        }
        this.updateFunc(this.form)
      }
    },
    resetError() {
      this.errors.user_details = {}
      this.errors.pass_access_questions = {}
      this.hasError = false
    }
  }
}
</script>

<style scoped>
.btn-active {
  background-color: #42bb79;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/containers/share/passes/PassShareStepUserDetails.vue